import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useChangeStatus = () => {
  const mutation = useMutation(({ statusId, usersIds }) => {
    return axiosClient.put(`/User/ChangeStatusUser?status=${statusId}`, usersIds);
  });
  return mutation;
};
export default useChangeStatus;
